import React, { useEffect } from 'react';
import { makersExperience } from '@fiverr-private/logo_maker_analytics';
import { briefRuntimeStore } from '@fiverr-private/variations_display';
import monitor from '../../../service/bigquery';
import { UserAgentContext } from '../../../shared/components/UserAgentContext';
import type { UserAgentData } from '../../../shared/lib/getUserAgent';
import type { TrackingData } from '../../../shared/lib/getTrackingData';
import topLevelSource from '../../../shared/storage/topLevelSource';
import { useOnceBeforeRender } from '../../../shared/hooks';
import BuyerIdeasPage from '../../components/BuyerIdeas/BuyerIdeasPage';

const { store: mixpanelStore } = makersExperience.buyerIdeas;

interface ClientBuyerIdeasPageProps {
  tagData: any;
  userAgent: UserAgentData;
  context: any;
  traffic: any;
  tracking: TrackingData;
}

export default function ClientBuyerIdeasPage({
  tagData,
  userAgent,
  context,
  traffic,
  tracking,
}: ClientBuyerIdeasPageProps) {
  useOnceBeforeRender(() => {
    monitor.initialize(tracking);
    mixpanelStore.tag.setData({
      tagType: tagData.tagType,
      tag: tagData.tagName,
    });
  });

  useEffect(() => {
    topLevelSource.setTopLevelSourceInStorage(topLevelSource.SOURCES.TAG_PAGE);
    briefRuntimeStore.clearBrief();
  }, []);

  return (
    <UserAgentContext.Provider value={userAgent}>
      <BuyerIdeasPage context={context} traffic={traffic} tracking={tracking} pageData={tagData} />
    </UserAgentContext.Provider>
  );
}
